import React, { useEffect, useState } from 'react';
import axios from 'axios';
import logo from '../common/images/icon/h-logo.svg';
import Cookies from 'js-cookie';

function Header() {
    const [HoverStatus, setHoverStatus] = useState(false);
    const [HeaderType, setHeaderType] = useState('');
    const [isLogin, setIsLogin] = useState(false);
    const headerHeight = 96;

    if ((Cookies.get('isLogin') ? true : false) === !isLogin) {
        setIsLogin(true);
    }

    const logout = async () => {
        const hostname = window.location.hostname;
        let isLocal = null;
        if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
            isLocal = false;
        } else {
            isLocal = true;
        }

        const logoutAxios = await axios.get(
            `${
                isLocal ? process.env.REACT_APP_PRODUCTION_API_URL : process.env.REACT_APP_LOCAL_API_URL
            }/wpal/logout`,
            {
                withCredentials: true,
            },
        );

        if (logoutAxios.status === 200) {
            setIsLogin(false);
            Cookies.remove('isLogin');
            window.location.href = '/';
        }
    };

    return (
        <div className='header__inner'>
            <div className='header__top'>
                <h1 className='logo'>
                    <a href='/'>
                        <img src={logo} alt='logo' />
                    </a>
                </h1>
                <div className='header__bot bot_top'>
                    <button
                        className='h-link h-link-reserve'
                        onMouseEnter={() => [setHoverStatus(true), setHeaderType('notice')]}
                        onMouseLeave={(e) =>
                            e.clientY < headerHeight ? setHoverStatus(false) : false
                        }
                    >
                        <span>공지사항</span>
                    </button>

                    <button
                        className='h-link h-link-service'
                        onMouseEnter={() => [setHoverStatus(true), setHeaderType('fare')]}
                        onMouseLeave={(e) =>
                            e.clientY < headerHeight ? setHoverStatus(false) : false
                        }
                    >
                        <span>운임안내</span>
                    </button>

                    <button
                        className='h-link h-link-mileage'
                        onMouseEnter={() => [setHoverStatus(true), setHeaderType('service')]}
                        onMouseLeave={(e) =>
                            e.clientY < headerHeight ? setHoverStatus(false) : false
                        }
                    >
                        <span>서비스요청</span>
                    </button>

                    <button
                        className='h-link h-link-notice'
                        onMouseEnter={() => [setHoverStatus(true), setHeaderType('group')]}
                        onMouseLeave={(e) =>
                            e.clientY < headerHeight ? setHoverStatus(false) : false
                        }
                    >
                        <span>단체견적/발권</span>
                    </button>
                </div>
                <div className='header__top-r'>
                    {isLogin ? (
                        <>
                            <a className='header-mypage' href='/mypage'>
                                <span>마이페이지</span>
                            </a>
                            <div className='header-account'>
                                <a onClick={() => logout()}>로그아웃</a>
                            </div>
                        </>
                    ) : (
                        <div className='header-account'>
                            <a href='/login'>로그인</a>
                        </div>
                    )}
                    <button className='header-search'>
                        <img src='../images/icon/h-serach.svg' alt='' />
                    </button>
                    <button className='mo_mypage'></button>
                    <button className='header-burger__btn'></button>
                </div>
            </div>
            {/* 헤더 hover시 */}
            <div
                className={`header__hidden ${HoverStatus ? 'opened' : ''}`}
                onMouseLeave={() => setHoverStatus(false)}
            >
                <div className='dropmenu-wrap'>
                    {/* 공지사항 */}
                    <div
                        className={`dropmenu-category dropmenu-reserve ticket_reservation_drop_menu ${
                            HeaderType === 'notice' ? 'show' : ''
                        }`}
                    >
                        <div className='dropmenu'>
                            <div className='dropmenu-icon'>
                                <a href='/notice/reservationrules'>
                                    <div className='menu-i menu-i-notice'></div>
                                </a>
                            </div>
                            <a className='h-main-menu'>규정 안내</a>
                            <a className='h-sub-menu' href='/notice/reservationrules'>
                                예약/발권 규정
                            </a>
                            <a className='h-sub-menu' href='/notice/reissuerules'>
                                재발행 규정
                            </a>
                            <a className='h-sub-menu' href='/notice/paidseatsbaggagerules'>
                                유료좌석/수하물 규정
                            </a>
                            <a className='h-sub-menu' href='/notice/cancelrefund'>
                                취소/환불 규정
                            </a>
                            <a className='h-sub-menu' href='/notice/waivercode'>
                                환불 웨이버 코드
                            </a>
                            <a className='h-sub-menu' href='/notice/Fueltaxinfo'>
                                유류/TAX 정보
                            </a>
                            <a className='h-sub-menu' href='/notice/Flightdelayinfo'>
                                운항(지연결항공문)
                            </a>
                            <a className='h-sub-menu' href='/notice/etc'>
                                기타
                            </a>
                        </div>
                        <div className='dropmenu'>
                            <div className='dropmenu-icon'>
                                <a href='/notice/faq?status=all'>
                                    <div className='menu-i menu-i-faq'></div>
                                </a>
                            </div>
                            <a className='h-main-menu' href='/notice/faq?status=all'>
                                자주 묻는 질문
                            </a>
                        </div>
                        <div className='dropmenu'>
                            <div className='dropmenu-icon'>
                                <a href='/notice/event?status=valid'>
                                    <div className='menu-i menu-i-event'></div>
                                </a>
                            </div>
                            <a className='h-main-menu' href='/notice/event?status=valid'>
                                이벤트/프로모션
                            </a>
                        </div>
                    </div>
                    {/* 운임안내 */}
                    <div
                        className={`dropmenu-category dropmenu-service ${
                            HeaderType === 'fare' ? 'show' : ''
                        }`}
                    >
                        <div className='dropmenu'>
                            <div className='dropmenu-icon'>
                                <a href='/fare/all'>
                                    <div className='menu-i menu-i-proof'></div>
                                </a>
                            </div>
                            <a className='h-main-menu' href='/fare/all'>
                                전체 요금 보기
                            </a>
                        </div>
                        <div className='dropmenu'>
                            <div className='dropmenu-icon'>
                                <a href='/fare/regular'>
                                    <div className='menu-i menu-i-ticket__change'></div>
                                </a>
                            </div>
                            <a className='h-main-menu' href='/fare/regular'>
                                정규 포괄 요금
                            </a>
                        </div>
                        <div className='dropmenu'>
                            <div className='dropmenu-icon'>
                                <a href='/fare/discount'>
                                    <div className='menu-i menu-i-sub__pal-pass'></div>
                                </a>
                            </div>
                            <a className='h-main-menu' href='/fare/discount'>
                                정규 특가 요금
                            </a>
                        </div>
                        {/* <div className='dropmenu'>
                            <div className='dropmenu-icon'>
                                <a href='/fare/special'>
                                    <div className='menu-i menu-i-scedule'></div>
                                </a>
                            </div>
                            <a className='h-main-menu' href='/fare/special'>
                                특정일 특가
                            </a>
                        </div> */}
                    </div>
                    {/* 서비스요청 */}
                    <div
                        className={`dropmenu-category dropmenu-mileage ${
                            HeaderType === 'service' ? 'show' : ''
                        }`}
                    >
                        <div className='dropmenu'>
                            <div className='dropmenu-icon'>
                                <a href='/service/standbyrequest'>
                                    <div className='menu-i menu-i-reserve'></div>
                                </a>
                            </div>
                            <a className='h-main-menu wpal-line-height-edit'>대기 전문 요청</a>
                            <a className='h-sub-menu' href='/service/standbyrequest'>
                                요청하기
                            </a>
                            <a className='h-sub-menu' href='/service/standbyList'>
                                요청 내역 확인
                            </a>
                        </div>
                        <div className='dropmenu'>
                            <div className='dropmenu-icon'>
                                <a href='/service/autoreissuerequest'>
                                    <div className='menu-i menu-i-scedule'></div>
                                </a>
                            </div>
                            <a className='h-main-menu'>
                                Auto 리이슈
                                <br />
                                -SC 티켓 Void 요청
                            </a>
                            <a className='h-sub-menu' href='/service/autoreissuerequest'>
                                요청하기
                            </a>
                            <a className='h-sub-menu' href='/service/reissueList'>
                                요청 내역 확인
                            </a>
                        </div>
                        <div className='dropmenu'>
                            <div className='dropmenu-icon'>
                                <a href='/service/scticketrequest'>
                                    <div className='menu-i menu-i-report'></div>
                                </a>
                            </div>
                            <a className='h-main-menu'>
                                Auto 리이슈
                                <br />
                                -SC 티켓 발송요청
                            </a>
                            <a className='h-sub-menu' href='/service/scticketrequest'>
                                요청하기
                            </a>
                            <a className='h-sub-menu' href='/service/scticketlist'>
                                요청 내역 확인
                            </a>
                        </div>
                        <div className='dropmenu'>
                            <div className='dropmenu-icon'>
                                <a href='/service/emdticketrequest'>
                                    <div className='menu-i menu-i-ticket'></div>
                                </a>
                            </div>
                            <a className='h-main-menu'>
                                EMD<br />
                                Reassociate 요청
                            </a>
                            <a className='h-sub-menu' href='/service/emdticketrequest'>
                                요청하기
                            </a>
                            <a className='h-sub-menu' href='/service/emdticketlist'>
                                요청 내역 확인
                            </a>
                        </div>
                        {/* <div className='dropmenu'>
                            <div className='dropmenu-icon'>
                                <a href='/service/involreissuerequest'>
                                    <div className='menu-i menu-i-report'></div>
                                </a>
                            </div>
                            <a className='h-main-menu'>
                                INVOL 재발행 요청
                                <br />
                                (Rerouting)
                            </a>
                            <a className='h-sub-menu' href='/service/involreissuerequest'>
                                요청하기
                            </a>
                            <a className='h-sub-menu' href='/service/involreissuelist'>
                                요청 내역 확인
                            </a>
                        </div> */}
                        <div className='dropmenu'>
                            <div className='dropmenu-icon'>
                                <a href='/service/seatrequest'>
                                    <div className='menu-i menu-i-inner__service'></div>
                                </a>
                            </div>
                            <a className='h-main-menu' style={{lineHeight: 2.5}}>유료 좌석 구매 요청</a>
                            <a className='h-sub-menu' href='/service/seatrequest'>
                                요청하기
                            </a>
                            <a className='h-sub-menu' href='/service/seatlist'>
                                요청 내역 확인
                            </a>
                        </div>
                    </div>
                    {/* 단체견적/발권 */}
                    <div
                        className={`dropmenu-category dropmenu-notice ${
                            HeaderType === 'group' ? 'show' : ''
                        }`}
                    >
                        <div className='dropmenu'>
                            <div className='dropmenu-icon'>
                                <a href='/group/bookingrequest'>
                                    <div className='menu-i menu-i-scedule'></div>
                                </a>
                            </div>
                            <a className='h-main-menu' href='/group/bookingrequest'>
                                단체 견적 문의
                            </a>
                            <a className='h-sub-menu' href='/group/bookingrequest'>
                                요청하기
                            </a>
                        </div>
                        <div className='dropmenu'>
                            <div className='dropmenu-icon'>
                                <a href='/group/atrrequest'>
                                    <div className='menu-i menu-i-ticket'></div>
                                </a>
                            </div>
                            <a className='h-main-menu' href='/group/atrrequest'>
                                ATR 발권 요청
                            </a>
                            <a className='h-sub-menu' href='/group/atrrequest'>
                                요청하기
                            </a>
                            <a className='h-sub-menu' href='/group/atrlist'>
                                요청 내역 확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Header;
